import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  logo
  public url : any; 

  constructor(
    private router: Router,
    private translateService: TranslateService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.url = event.url;
      }
    });
  }

  ngOnInit() {
    this.getLogo()
    this.translateService.onLangChange.subscribe(data => {
      this.getLogo()
    })
  }

  getLogo() {
    if(this.translateService.currentLang == 'zh') {
      this.logo = 'assets/custom/images/logo_zh.png'
    }
    else {
      this.logo = 'assets/custom/images/logo.png'
    }
  }

}
